import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const GridViewListTDAs = gql`
    query GridViewListTDAs ($typeDefinitionIndex: GridViewTypeDefinitionIndex) {
        gridViewList {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
